import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Renderer2 } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';

@Component({
  selector: 'fpx-amount-slider',
  templateUrl: './fpx-amount-slider.component.html',
  styleUrls: ['./fpx-amount-slider.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FpxAmountSliderComponent,
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FpxAmountSliderComponent extends BaseFpxControlComponent {
  
  @Input() min: string = '0';
  @Input() max: string = '100';
  @Input() step: string = '1';
  @Input() disabled: boolean = false;
  @Input() sliderValue: string | number = 0;

  _currencyCode:string = 'USD';
  @Input()
  set currencyCode(currency:string) {
    this._currencyCode = currency;
    this.updateFormat(this._currencyCode);
  }
  get currencyCode(){
    return this._currencyCode;
  }

  // fieldValue:number = 0;
  seperatorLength: any = 0;
  maskText:any = 'separator.0';
  amountMaskFormat:any = '';
  thousandSeparator: any = ',';
  
  constructor(
    controlContainer: ControlContainer, 
    private _changeDetector: ChangeDetectorRef,
    private _renderer: Renderer2) {
    super(controlContainer, _changeDetector);
  }

  override doPreInit() {
    this.sliderValue = this.formControl.value;
  }

  updateRangeBar(event) {
    this.sliderValue = event.value;
    this.formControl.patchValue(event.value, {emitEvent: false});
  }

  doValueChange(event){

    this.formControl.patchValue(this.sliderValue, {});
    this.formControl.markAllAsTouched()
  }

  updateFormat(currency:string){
    switch (currency) {
      case "JOD":
        this.seperatorLength = 3;
        break;
      case "JPY":
        this.seperatorLength = 0;
        break;
      default:
        this.seperatorLength = 2;
        break;
    }

    this.amountMaskFormat = this.maskText + this.thousandSeparator + this.seperatorLength;
    this._changeDetector.markForCheck();
  }

}
